import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createI18n } from 'vue-i18n';

import App from './App.vue';
import { useCalculatorStore } from './state/calculatorStore';
import { ScenarioRepository } from './state/scenarioRepository';
import en from './i18n/en.json';
import cs from './i18n/cs-CZ.json';
import './styles/main.css';

const i18n = createI18n({
  legacy: false,
  locale: 'cs-CZ',
  fallbackLocale: 'en',
  messages: {
    cs,
    'cs-CZ': cs,
    en,
  },
});

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);

const store = useCalculatorStore();

if (typeof window !== 'undefined' && window.localStorage) {
  const repository = new ScenarioRepository(window.localStorage);
  const persisted = repository.load();
  if (persisted.scenarios.length > 0 && persisted.selectedId) {
    const scenario = persisted.scenarios.find((s) => s.id === persisted.selectedId);
    if (scenario) {
      store.loadScenario(scenario);
    }
  }
}

app.use(i18n);
app.mount('#app');